type AppendAttributes = Record<string, string | number | boolean>;

export function exists(tag: string, src: string | number | boolean) {
    return !!document.querySelectorAll(`${tag}[src="${src}"]`).length;
}

/**
 * Append built script to head
 *
 * @param tag
 * @param attrs
 * @param onload
 */
export function append(tag: string, attrs: AppendAttributes = {}, onload?: () => void) {
    if (exists(tag, attrs.src)) return onload?.();

    const newScript = document.createElement(tag);

    Object.entries(attrs).forEach(([name, value]) => {
        newScript.setAttribute(name.toString(), value.toString());
    });

    newScript.onload = () => {
        onload?.();
    };

    document.getElementsByTagName('head')[0].appendChild(newScript);
}

export function script(src: string, async = true, attrs: AppendAttributes = {}, onload?: () => void) {
    append('script', { src, async, ...attrs }, onload);
}

export function style(href: string, attrs: AppendAttributes = {}, onload?: () => void) {
    append('link', {
        href,
        rel:  'stylesheet',
        type: 'text/css',
        ...attrs,
    }, onload);
}
